import type { FC } from "react";
import { useDispatch } from "react-redux";
import { titleCase } from "title-case";
import { ActionButton, ActionButtonIntent, ActionButtonSize, HStack } from "widgets";

import type { IJnlpDownloadInputData } from "@/redux/modules/files.ts";
import { downloadJnlpFile } from "@/redux/modules/files.ts";
import type { ReduxDispatch } from "@/redux/redux-utils.ts";
import { ENTITY_TYPE, EXT_APP_MODULES } from "@/settings/settings.ts";
import { EllipsedContent } from "@/ui-modules/core/grid/cells/core/EllipsedContent.tsx";

import type { IAgGridCellProps } from "../cell-base-interfaces.js";
import { TableCell } from "./core/TableCell.js";

const JnlpFileCell: FC<IAgGridCellProps> = (props) => {
  const dispatch = useDispatch<ReduxDispatch>();

  if (!props.value || !props.data) {
    return null;
  }
  const { data, value } = props;
  const { id, groupType } = data;

  let moduleId: string | null = null;
  switch (groupType) {
    case ENTITY_TYPE.ANALYST_SESSION:
      moduleId = titleCase(EXT_APP_MODULES.ANALYST.id);
      break;
    case ENTITY_TYPE.WORKFLOW_SESSION:
      moduleId = titleCase(EXT_APP_MODULES.PROCESSOR.id);
      break;
    default:
      throw Error(`Unknown session type ${groupType}`);
  }

  const jnlpDownloadPayload: IJnlpDownloadInputData = {
    moduleId: moduleId,
    sessionId: id,
  };

  return (
    <TableCell>
      <HStack>
        <EllipsedContent tooltip={value} style={{ flex: 1 }}>
          {value}
        </EllipsedContent>
        <ActionButton
          {...props}
          label={`Open in ${moduleId}`}
          onPress={() => dispatch(downloadJnlpFile(jnlpDownloadPayload))}
          size={ActionButtonSize.Small}
          intent={ActionButtonIntent.Outlined}
        />
      </HStack>
    </TableCell>
  );
};

export default JnlpFileCell;
